// extracted by mini-css-extract-plugin
export default {"ArticleText":"ArticleText_sQ6q1"};